import Vue from 'vue'
import axios from 'axios'
import qs from 'qs';
import $ from 'jquery'
let wxConfidReady = false
let wxConfigSuccess = false
let logInstance = new Vue()
let loadingDom = null
let asyncStartTime = 0 // 记录微信jssdk加载到wx.ready触发的时长
let domReadyTime = 0 // 记录微信开放标签的初始化时长

// 异步加载微信jssdk
export const asyncWeiXinJS = (cb) => {
  asyncStartTime = new Date().getTime()
  if (true || isWeixinFn()) {
    const script = document.createElement('script')
    script.src = '//res.wx.qq.com/open/js/jweixin-1.6.0.js'
    document.body.appendChild(script)
    if (cb) {
      script.addEventListener('load', cb)
    }
  }
}
// 判断微信内浏览器环境
export const isWeixinFn = () => { // 判断是否是微信
  const ua = navigator.userAgent.toLowerCase();
  return ua.indexOf('micromessenger') !== -1
}
// 页面loading遮罩层
const addLoading = function () {
  const vm = new Vue({
    data () {
      return {
        show: true
      }
    },
    template: `
    <div v-if="show" style="position: fixed;
      top: 0;
      left: 0;
      z-index: 9999;
      width: 100%;
      height: 100%;
      background-color: rgba(0,0,0,.6);
    ">
      <div style="display: flex;
        align-items: center;
        justify-content: center;
        height: 100%;">
        <van-loading type="spinner" />
      </div>
    </div>`
  }).$mount()
  loadingDom = vm.$el
  document.body.append(loadingDom)
}
// 移除loading
const removeLoading = function () {
  try {
    setTimeout(() => {
      if (loadingDom) {
        document.body.removeChild(loadingDom)
        loadingDom = null
      }
    }, 300)
  } catch (e) {
    console.log(e)
  }
}
// 微信jssdk config校验
export const wxConfig = async () => {
  console.log("here is wxConfig ", wxConfidReady);
  if (wxConfidReady) return
  addLoading()
   let timeId = setTimeout(() => {
    alert("网络超时，请稍后刷新再试");
    removeLoading()
  }, 12000)
  let res = await axios.post('http://wx-restaurants.twomiles.cn:8050/wxLaunchAppConfig', qs.stringify({infoUrl: window.location.href}));
  let wxConf = res.data.data; 
  clearTimeout(timeId);
  wxConf.openTagList = ['wx-open-launch-app'];
  wxConf.jsApiList = ['onMenuShareTimeline', 'onMenuShareAppMessage'];
  console.log('wxConf:', wxConf)
  // wxConf.debug = true
  window.wx.config(wxConf);
  window.wx.ready(function () {
    domReadyTime = new Date().getTime()
    console.log('wx.ready时间', (new Date().getTime() - asyncStartTime) + 'ms')
    wxConfidReady = true
    domTraverse();
    removeLoading()
  })
  window.wx.error(function (res) {
    alert("初始化失败，请稍后刷新再试");
    console.log('==wx.error==', res)
    wxConfidReady = true
    wxConfigSuccess = true
    // removeLoading()
  })
}

export const getExtInfo = (serach) => {
  var signStr = getQueryString(window.location.search.substr(1), serach) || '';
  // console.log("eeeeeeeee ", window.location.href, window.location.search);
  function getQueryString(str, name) {
    var reg = new RegExp(`${name}=([^&]*)`)
    var r = str.match(reg)
    if (r != null) {
        return r[1]
    }
    return null
  }
  return signStr;
}

export const createOpenApp = (root, schema) => {
  root.setAttribute('launch-box-created', true)
  const box = document.createElement('div')
  // 创建开放标签
  const clickDom = document.createElement('wx-open-launch-app')
  box.appendChild(clickDom)
  // 设置Shadow host节点css样式，是其可以完全覆盖在目标元素上。注意设置overflow:hidden;属性
  box.style.width = root.clientWidth + 'px'
  box.style.height = root.clientHeight + 'px'
  box.style.position = 'absolute'
  box.style.top = '0'
  box.style.left = '0'
  box.style.zIndex = '999'
  box.style.overflow = 'hidden'
  box.setAttribute('class', 'launch-app-box')
  // 模板内容样式特殊处理为width: 1000px; height: 1000px;目的是能完全覆盖
  clickDom.innerHTML =
    `<template>
      <style>
        .btn {
          width: 1000px;
          height: 1000px;
        }
      </style>
      <div class="btn"><div>
    </template>`
  let extinfo = getExtInfo("info");  
  clickDom.setAttribute('extinfo', extinfo)
  clickDom.setAttribute('appid', 'wx4297cf03e4daa5fa')
  if (window.getComputedStyle(root, null).position === 'static') {
    // 为目标元素设置position属性
    root.style.position = 'relative'
  }
  root.appendChild(box)
  clickDom.addEventListener('ready', function () {
    console.log('dom ready', new Date().getTime() - domReadyTime)
    removeLoading() // 移除loading遮罩
  })
  clickDom.addEventListener('click', function (e) {
      console.log("here is click");
      e.preventDefault()
  })
  clickDom.addEventListener('launch', function (e) {
    console.log('success', e);
  })
  clickDom.addEventListener('error', function (e) {
    console.log('fail', e.detail)
  })
}

export const domTraverse = function (rootElement) {
  const startTime = new Date().getTime()
  let domList = []
  if (rootElement) {
    domList = rootElement.getElementsByClassName('root-wx-open-launch-app')
  } else {
    domList = document.getElementsByClassName('root-wx-open-launch-app')
  }
  let j = 0
  for (let i = 0; i < domList.length; i++) {
    const item = domList[i]
    const schema = item.getAttribute('schema')
    const launchCreated = item.getAttribute('launch-box-created')
    if (!launchCreated) {
      j++;
      createOpenApp(item, schema);
    }
  }
  console.log('开放标签数量：', j)
  console.log('所有开放标签创建花费时间：', (new Date().getTime() - startTime) + 'ms')
}

/* 应对简单场景页面，直接调用该方法即可，
 * 由于是对dom进行操作，如果复杂异步渲染dom的场景可以酌情组合使用asyncWeiXinJS，wxConfig，domTraverse等方法
*/
export const createWXOpenTag = function () {
  let extinfo = getExtInfo("info");
  if (isWeixinFn()) {
      // domTraverse();
      let channel = getExtInfo("channel")
      if (channel === "HUAWEI") {
        alert("请复制链接到浏览器中打开")
      } else {
        asyncWeiXinJS(() => {
          wxConfig();
        });
      }
  } else {
    console.log("不是微信环境");
    window.top.location.href = 'https://restaurant.dhgames.cn/download_ex_share.html?info=' + extinfo;
  }
  let res = axios.post('https://ios-inland-restaurant.twomiles.cn:8060/uploadHalloweenInvite', qs.stringify({signKey: extinfo}));
}  


// WEBPACK FOOTER //
// ./src/units.js